import React from 'react'
import { withNamespaces } from 'react-i18next'
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import i18next from 'i18next'
import { IsEnglish } from '../../utils/language'
import PropTypes from 'prop-types'
import styles from '../../styles/loginCompany.module.css'
import * as AccessTypeMode from '@scripts/AccessTypeMode';

const menuProps = {
    getContentAnchorEl: null,
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
    }
};

const useStyles = makeStyles((theme) => ({
    formSelect: {
        width: '90%',
        '& .MuiInput-formControl': {
            width: '100%'
        }
    },
}));

function LoginWorksiteForm(props) {

    const [worksite, setWorksite] = React.useState(null);

    const { worksitesList, onChange } = props;

    const classes = useStyles();

    const onChangeWorksite = (event) => {
        setWorksite(event.target.value);
        onChange(event.target.value, AccessTypeMode.Supervisor);
    }

    return (
        <div className={styles.divRootSelect}>
            <FormControl className={classes.formSelect}>
                <div className={styles.divFormSelect}>
                    <InputLabel id="label-worksites">{i18next.t('login:login.worksite.form.worksite')}</InputLabel>
                    <Select
                        MenuProps={menuProps}
                        labelId="label-worksites"
                        id="worksite"
                        value={worksite || ''}
                        onChange={onChangeWorksite}
                    >
                        {worksitesList && worksitesList.map((obj, index) =>
                            <MenuItem key={index} className={styles.selectItem} value={`${obj.company}|${obj.worksite}`}>{IsEnglish() ?
                                `${obj.company} - ${obj.companyDescriptionEnglish}, ${obj.worksite} - ${obj.worksiteDescriptionEnglish}` :
                                `${obj.company} - ${obj.companyDescriptionFrench}, ${obj.worksite} - ${obj.worksiteDescriptionFrench}`}
                            </MenuItem>
                        )}
                    </Select>
                </div>
            </FormControl>
        </div>
    )
}

export default withNamespaces(['login'], { wait: true })(LoginWorksiteForm);

LoginWorksiteForm.propTypes = {
    worksitesList: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired
}